// Mirrors outreach/app/campaigns/rendering.py: spintax first, then variables.
// The server still owns the real render - this only has to agree with it about
// what a lead ends up seeing, and about which variable would block the send.
const VARIABLE_RE = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;
const SPINTAX_RE = /\{([^{}]*\|[^{}]*)\}/g;

// The server picks per lead from a hash; a preview has one lead, so it shows
// the first option and says so rather than pretending the choice is fixed.
export function expandSpintax(text) {
  let previous = null;
  let current = text;
  while (previous !== current) {
    previous = current;
    current = current.replace(SPINTAX_RE, (_, options) => options.split('|')[0]);
  }
  return current;
}

export function hasSpintax(text) {
  return SPINTAX_RE.test(text);
}

// Returns the text split into plain runs and the variables that resolved to
// nothing, so the caller can mark exactly the ones that would fail the send.
export function renderPreview(text, values, defaults) {
  const segments = [];
  const missing = [];
  let cursor = 0;
  const expanded = expandSpintax(text || '');

  for (const match of expanded.matchAll(VARIABLE_RE)) {
    const name = match[1];
    const resolved = values[name] || defaults[name] || '';
    if (match.index > cursor) segments.push({ text: expanded.slice(cursor, match.index) });
    if (resolved) {
      segments.push({ text: resolved, filled: true });
    } else {
      segments.push({ text: match[0], missing: true });
      missing.push(name);
    }
    cursor = match.index + match[0].length;
  }
  if (cursor < expanded.length) segments.push({ text: expanded.slice(cursor) });
  return { segments, missing };
}

export function contactValues(contact) {
  if (!contact) return {};
  const values = {
    email: contact.email,
    first_name: contact.first_name,
    last_name: contact.last_name,
    company: contact.company,
    title: contact.title,
    country: contact.country,
    website: contact.website,
    ...(contact.custom_fields || {}),
  };
  return Object.fromEntries(Object.entries(values).filter(([, value]) => value));
}
